export default __webpack_public_path__ + "static/media/auth_icon.c8645512.png";